import type { ColumnTypeValue } from '@cli-types/core-engine/schema.js'
import { COLUMN_TYPES } from '@cli-constants/schema.js'

export function isColumnType(value: string): value is ColumnTypeValue {
  return Object.values(COLUMN_TYPES).includes(value as ColumnTypeValue)
}
